import { render, staticRenderFns } from "./LayoutWrapper.vue?vue&type=template&id=c020c162"
import script from "./LayoutWrapper.vue?vue&type=script&lang=js"
export * from "./LayoutWrapper.vue?vue&type=script&lang=js"
import style0 from "./LayoutWrapper.vue?vue&type=style&index=0&id=c020c162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports